<template>
    <div>
        <VJoyButton variant="primary" @click="openModal">
            {{ $t('customer.freelancer.pof.create.favorites.list') }}
        </VJoyButton>
    </div>
</template>

<script setup lang="ts">
    import {VJoyButton} from '@maltjoy/core-vue';
    import {eventBus} from '~/config/events';
    import type {FreelancerProfile} from '../types';

    const props = defineProps<{
        profile: FreelancerProfile;
    }>();

    const {emit} = eventBus;

    function openModal() {
        emit('profile-card:favorite:create-list:open-dialog', props.profile);
        emit('profile-card:favorite:add-profile:close-dialog');
    }
</script>
